module.exports = __webpack_public_path__ + "src/assets/img/bg-money.d89c7680.png";